// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nw_Z","importantInfo":"styles_importantInfo__3Qs-O"};